export default __webpack_public_path__ + "c5ee50e0eaf499e7a4586766a2a8e047.png";